export default __webpack_public_path__ + "static/media/bootcamp.2ba82794.png";